module.exports = __webpack_public_path__ + "static/media/fly0234.d259b4d9.webp";